import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import {
  CustomSelect,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import CustomSwitch from "components/Input/CustomSwitch.js";
import { putMBMEquipment, postFileUpload, getProfilePicture } from "services/ConfigServices";
import styled from "styled-components";
import { definitionData, updategroupchoiceData, eosprotocoleDataSelect, equipmentcriticityData } from "variables/MBM/lists/equipments";
import { equipmenttext } from "variables/MBM/equipments";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import { hardwareData } from "variables/MBM/lists/equipments";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const HeaderId = styled.div`
  font-size: 14px;
  font-weight: 500;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function EquipmentDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;
  const { closeModal, refetch, setLoading, setNotification, equipment, iotdata } = props;
  const [name, setName] = useState(equipment.name || "");
  const [definition, setDefinition] = useState(equipment.definition || "");
  const [hardware, setHardware] = useState(equipment.otherproperties?.hardware || "");
  const [equipmentcriticity, setEquipmentcriticity] = useState(equipment.otherproperties?.equipmentcriticity || "");
  const [eosprotocol, setEosprotocol] = useState(equipment.connectionproperties?.eosprotocol || "");
  const [iotdevice, setIotdevice] = useState(equipment.connectionproperties?.iotdevice || "");
  const [subequipmentid, setSubequipmentid] = useState(equipment.connectionproperties?.id || "");

  const [connectionproperties, setConnectionproperties] = useState(equipment.connectionproperties || {});
  const [otherproperties, setOtherproperties] = useState(equipment.otherproperties || {});
  const [groupid, setGroups] = useState(equipment.groupid ? "" + equipment.groupid : "");
  const [updategroupchoice, setUpdategroupchoice] = useState("equipmentonly");
  const [groupchanged, setGroupchanged] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [imageUrl, setImageUrl] = useState(null);
  const [imageCode, setImageCode] = useState(equipment.otherproperties?.imageCode || null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);

  const selectedDefinition = () => {
    let selected = definitionData.find((obj) => obj.id == definition);
    return selected;
  };
  const handleDefinitionChange = (selected) => { setDefinition(selected?.id || ""); };

  const selectedHardware = () => {
    let selected = hardwareData.find((obj) => obj.id == hardware);
    return selected;
  };
  const handleHardwareChange = (selected) => { setHardware(selected?.id || ""); };
  const handleEquipmentcriticityChange = (event) => { setEquipmentcriticity(event.target.value); };

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleUpdategroupchoiceChange = (event) => { setUpdategroupchoice(event.target.value); };
  const handleEosprotocolChange = (event) => { setEosprotocol(event.target.value); };

  const selectedIot = () => {
    let selected = iotdata.find((obj) => obj.id == iotdevice);
    return selected;
  };
  const handleIotChange = (selected) => { setIotdevice(selected?.id || ""); };

  const handleSubequipmentidChange = (event) => { setSubequipmentid(event.target.value); };

  const classes = useStyles();


  const handleSubmit = (event) => {
    updateEquipment(event);
    closeModal();
  };

  useEffect(() => {
    if (imageCode) {
      setImageCode(imageCode);
      setImagePreviewUrl(getProfilePicture(imageCode));
    }
  }, []);

  useEffect(() => {
    if (!name || !definition || !groupid || groupid.length === 0)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
    if (groupid !== ("" + equipment.groupid))
      setGroupchanged(true);
    else
      setGroupchanged(false);
  }, [name, groupid, definition]);




  const updateEquipment = async (event) => {
    axios
      .put(
        putMBMEquipment(equipment.id, groupchanged ? updategroupchoice : "iotonly"),
        {
          ...equipment,
          name,
          definition,
          groupid,
          otherproperties: {
            ...otherproperties,
            imageCode,
            hardware,
            equipmentcriticity
          },
          connectionproperties: {
            ...connectionproperties,
            id: subequipmentid,
            iotdevice
          }
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Equipement modifié");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });
  };

  //Profile picture
  useEffect(() => {
    if (imageUrl) {
      const formData = new FormData();
      // we append each element to the form
      formData.append("files", imageUrl);
      axios
        .post(postFileUpload(groupid, "profilepic"), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          //console.log(res.data);
          //console.log(res.data.files[0].url);
          setImageCode(res.data.files[0].url);
          setImagePreviewUrl(getProfilePicture(res.data.files[0].url));
        })
        .catch(() => { });
    }
  }, [imageUrl]);

  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <HeaderId>Id : {equipment.id}</HeaderId>
            <div>
              <TextInput
                inputTitle={equipmenttext.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <AutocompleteInputMeters
                specialWidth={"97%"}
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={equipmenttext.definition}
                selected={selectedDefinition()}
                list={definitionData}
                handleChange={(_, newValue) =>
                  handleDefinitionChange(newValue)
                }
              />
            </div>
            <div>
              <AutocompleteInputMeters
                specialWidth={"97%"}
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={equipmenttext.hardware}
                selected={selectedHardware()}
                list={hardwareData}
                handleChange={(_, newValue) =>
                  handleHardwareChange(newValue)
                }
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={equipmenttext.equipmentcriticity}
                selectValue={equipmentcriticity}
                handleSelectValueChange={handleEquipmentcriticityChange}
                data={equipmentcriticityData}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={equipmenttext.eosprotocol}
                selectValue={eosprotocol}
                handleSelectValueChange={handleEosprotocolChange}
                data={eosprotocoleDataSelect}
              />
            </div>
            {
              eosprotocol === 'lorawan' ?
                <>
                  <div>
                    <AutocompleteInputMeters
                      specialWidth={"97%"}
                      inputMargin={"1rem 0rem 0rem"}
                      inputTitle={equipmenttext.iot}
                      selected={selectedIot()}
                      list={iotdata}
                      handleChange={(_, newValue) =>
                        handleIotChange(newValue)
                      }
                    />
                  </div>
                  <div>
                    <TextInput
                      inputTitle={equipmenttext.subequipmentid}
                      textInput={subequipmentid}
                      handleTextInputChange={handleSubequipmentidChange}
                    />
                  </div>
                </>
                : <></>
            }
            <div style={{ paddingLeft: "8px", paddingTop: "8px" }}>
              <ImageUpload
                file={imageUrl}
                setImageCode={setImageCode}
                setFile={setImageUrl}
                imagePreviewUrl={imagePreviewUrl}
                setImagePreviewUrl={setImagePreviewUrl}
                disabled={!groupid}
              />
            </div>
            {
              groupchanged ?
                <div>
                  <CustomSelect
                    inputTitle={equipmenttext.updategroupchoice}
                    selectValue={updategroupchoice}
                    handleSelectValueChange={handleUpdategroupchoiceChange}
                    data={updategroupchoiceData}
                  />
                </div>
                : <></>
            }

          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div
              className={classes.treeVisible}
            >
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groupid}
                />
              </ImageList>
            </div>
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>

    </>
  );
}

export default EquipmentDialog;
